import {eventBus} from "@/plugins/event_bus/event_bus"
import {eventBindMarkComplete} from "./data"

function bindListener(fn) {
    eventBus.on(eventBindMarkComplete, fn)
}

function unbindListener(fn) {
    eventBus.off(eventBindMarkComplete, fn)
}

export default {
    bindListener,
    unbindListener,
}